<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-form ref="form" v-model="computedIsValid">
        <v-row v-for="(option, idx) of printOptionsItems" :key="idx" no-gutters>
          <v-col cols="12">
            <v-select
              v-bind="option"
              v-model="computedValue[option.name]"
              :label="$i18n.t(`dialog.print.${option.name}`)"
              :menu-props="{ offsetY: true }"
              :rules="[v => !!v || $i18n.t('default.ruleNoEmpty')]"
              outlined
            />
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    isValid: {
      type: Boolean,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedIsValid: {
      get() {
        return this.isValid;
      },
      set(nV) {
        this.$emit('update:isValid', nV);
      }
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('update:value', nV);
      }
    },
    printOptionsItems() {
      return [
        {
          name: 'printingType',
          items: [
            {
              text: this.$i18n.t('dialog.print.printoutBasic'),
              value: 'basic'
            },
            {
              text: this.$i18n.t('dialog.print.printoutCadastral'),
              value: 'cadastral'
            }
          ]
        },
        {
          name: 'paperFormat',
          items: ['A4', 'A3', 'A2', 'A1', 'A0']
        },
        {
          name: 'resolution',
          items: [
            {
              text: '150 DPI',
              value: 150
            },
            {
              text: '300 DPI',
              value: 300
            }
          ]
        },
        {
          name: 'orientation',
          items: [
            {
              text: this.$i18n.t('dialog.print.portrait'),
              value: 'portrait'
            },
            {
              text: this.$i18n.t('dialog.print.landscape'),
              value: 'landscape'
            }
          ]
        },
        {
          name: 'fileFormat',
          items: ['JPEG', 'PNG', 'PDF']
        }
      ];
    }
  }
};
</script>